import {config} from './config/slider'

const galleryWrapper = '.galleryWrapper';
const galleryImage = '.galleryItemImage';
const galleries = $('.gallery-slider');
const fullscreenCls = 'fullScreen';

galleries.each((i, gallery) => {
    gallery = $(gallery);
    const galleryItem = $('.galleryItem', gallery);
    const galleryItemDesc = $('.galleryItemDesc', gallery);
    galleryItemDesc.hide();
    if (galleryItem.length > 1 || galleryItem.find('.galleryItemDesc').length > 0) {
        galleryItemDesc.show();
    }
    if (galleryItem.length > 1) {
        galleryItem.each((_, item) => {
            if ($(item).find('.galleryItemDesc').length == 0) {
                $(item).append("<div class='galleryItemDesc slick_arrow_container' />");
            }
        })
        gallery.slick({
            ...config,
            variableWidth: false,
            slidesToShow: 1,
            responsive: [],
            infinite: true,
            dots: true,
            prevArrow: '<span class="gallery-prev" aria-label="Previous" type="button">\n' +
                '                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" xml:space="preserve">\n' +
                '                                <path d="M14.4 15.1 11.3 12l3.1-3.1L13 7.5 8.5 12l4.5 4.5 1.4-1.4zM22 12c0-5.5-4.5-10-10-10S2 6.5 2 12s4.5 10 10 10 10-4.5 10-10zM4 12c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8-8-3.6-8-8z"/>\n' +
                '                                </svg>\n' +
                '                            </span>',
            nextArrow: '<span class="gallery-next" aria-label="Next" type="button">\n' +
                '                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" xml:space="preserve">\n' +
                '                                <path d="m9.6 8.9 3.1 3.1-3.1 3.1 1.4 1.4 4.5-4.5L11 7.5 9.6 8.9zM2 12c0 5.5 4.5 10 10 10s10-4.5 10-10S17.5 2 12 2 2 6.5 2 12zm18 0c0 4.4-3.6 8-8 8s-8-3.6-8-8 3.6-8 8-8 8 3.6 8 8z"/>\n' +
                '                                </svg>\n' +
                '                            </span>',
        });
    }
});

const resizeGalleries = () => {
    $.each(galleries, (i, gallery) => {
        if ($(gallery).hasClass('slick-initialized')) {
            $(gallery).slick('setDimensions').slick('setPosition');
        }
    });

    setDescriptionHeight();
};


const setDescriptionHeight = () => {
    $.each(galleries, (i, gallery) => {
        let textBlocks = $('.galleryItemDesc', gallery);
        let maxHeightOfTextBlock = 0;

        $.each(textBlocks, (i, block) => {
            block.style.height = `auto`;
        })
        $.each(textBlocks, (i, block) => {
            if (block.clientHeight > maxHeightOfTextBlock) {
                maxHeightOfTextBlock = block.clientHeight
            }
        })

        $.each(textBlocks, (i, block) => {
            if (maxHeightOfTextBlock < 20) {
                block.style.display = 'none'
            } else {
                block.style.height = `${maxHeightOfTextBlock}px`
            }
        })

        if (maxHeightOfTextBlock > 0) {
            $(galleryWrapper).addClass('showImageDescriptions');
        }
    })
}

setDescriptionHeight();

galleries.on('click', galleryImage, (event) => {
    event.preventDefault();
    $(event.target).closest(galleryWrapper).addClass(fullscreenCls);
    const thisGallery = $(event.target).parents('.gallery-slider');
    if (thisGallery.hasClass('slick-initialized')) {
        thisGallery.slick('setDimensions').slick('setPosition');
    }
});

galleries
    .closest(galleryWrapper)
    .on('click', '.close', (event) => {
        event.preventDefault();
        $(event.target).closest(galleryWrapper).removeClass(fullscreenCls);
        const thisGallery = $(event.target).parent('.close').siblings('.gallery-slider');
        if (thisGallery.hasClass('slick-initialized')) {
            thisGallery.slick('setDimensions').slick('setPosition');
        }
    });

$(document).on('keyup', (event) => {
    if (event.originalEvent.key === 'Escape') {
        const fullscreenGallery = $('.galleryWrapper.fullScreen').find('.gallery-slider');
        galleries.closest(galleryWrapper).removeClass(fullscreenCls);
        if (fullscreenGallery.hasClass('slick-initialized')) {
            fullscreenGallery.slick('setDimensions').slick('setPosition');
        }
    }
});

$(window).on('resize orientationchange', resizeGalleries);

